import React, { useState } from "react";
import { 
  FaUser, FaBook, FaSchool, FaCalendarAlt, 
  FaMosque, FaPrayingHands, FaQuestionCircle, 
  FaStar, FaLibrary, FaChild, FaBlog, FaLandmark,
  FaBookReader,
  FaBookOpen,
  FaUsers
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./Sidebar.css";
import MenuModal from "./MenuModal";
import { AuthContext } from "../../context/Authcontext";

const routeMap = {
  users: "admin/users",
  pandits: "admin/pandits",
  departments: "admin/departments",
  events: "admin/events",
  quizzes: "admin/quizzes",
  prayers: "admin/prayers",
  specialdays: "admin/specialdays",
  mandirs: "admin/mandirs",
  hindilearning: "admin/hindilearning",
  kinderhuis: "admin/kinderhuis",
  ebibliotheek: "admin/ebibliotheek",
  dharmalearning: "admin/dharmalearning",
  schools: "admin/schools",
  hoofdbestuur: "admin/hoofdbestuur",
  blogs: "admin/blogs",
};

const icons = {
  users: <FaUser />,
  pandits: <FaUsers />,
  departments: <FaBook />,
  events: <FaCalendarAlt />,
  quizzes: <FaQuestionCircle />,
  prayers: <FaPrayingHands />,
  specialdays: <FaStar />,
  mandirs: <FaMosque />,
  hindilearning: <FaBook />,
  kinderhuis: <FaChild />,
  ebibliotheek: <FaBookReader />,
  dharmalearning: <FaBookOpen />,
  schools: <FaSchool />,
  hoofdbestuur: <FaLandmark />,
  blogs: <FaBlog />,
};

const labels = {
  users: "Users",
  pandits: "Pandits",
  departments: "Departments",
  events: "Events",
  quizzes: "Quizzes",
  prayers: "Prayers",
  specialdays: "Special Days",
  mandirs: "Mandirs",
  hindilearning: "Hindi Learning",
  kinderhuis: "Kinderhuis",
  ebibliotheek: "E-Bibliotheek",
  dharmalearning: "Dharma Learning",
  schools: "Schools",
  hoofdbestuur: "Hoofdbestuur",
  blogs: "Blogs",
};

export default function Sidebar() {
  const [isModalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  const { user } = React.useContext(AuthContext);
  
  if (!user) {
    navigate("/");
    return null;
  }

  return (
    <>
      <aside className="sidebar">
        <img src="/logo.png" alt="Logo" className="logo" title="Dashboard" onClick={() => navigate(`/dashboard`)} />
        <ul>
          {Object.keys(routeMap).map((key) => (
            <li key={key} title={labels[key]} onClick={() => navigate(`/${routeMap[key]}`)}>
              {icons[key]}
              <span className="label">{labels[key]}</span>
            </li>
          ))}
        </ul>
        <button className="expand-btn" onClick={() => setModalOpen(true)}>
          Menu
        </button>
      </aside>

      {isModalOpen && (
        <MenuModal
          routeMap={routeMap}
          icons={icons}
          labels={labels}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
